import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Avatar, Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import * as S from './DealRoomAgencyInfo.styles';
import IntroUserIcon from 'assets/images/intro-user.png';
import TarbutIcon from 'assets/images/tarbut-logo.png';

const { Title, Paragraph, Text } = Typography;

export const { Panel } = Collapse;

const DealRoomAgencyInfo: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();
  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          הסוכנות המובילה בישראל
          <br />
          לביטוח בתים משותפים
        </Title>
      </S.Header>

      <S.Intro>
        <Paragraph>אנו שמחים להציג לך את הסוכנות המובילה והוותיקה ביותר בישראל בתחום ביטוח הבתים המשותפים.</Paragraph>
        <Paragraph>בשנת 1973 נוסדה סוכנות הביטוח בר-עוז המרכז לביטוח בתים משותפים, ומאז היא המובילה בתחום.</Paragraph>
        <Paragraph>הסוכנות הינה הייחידה בישראל, +שמתמקדת ומומחית אך ורק בביטוח בתים משותפים,</Paragraph>
        <Paragraph>דבר שמאפשר לנו לתת את השירות המקצועי והמדויק ביותר בתחום.</Paragraph>
      </S.Intro>

      <S.SectionTitle level={4}>מה מייחד אותנו?</S.SectionTitle>

      <S.Features>
        <S.FeatureItem>
          <S.NumberCircle>1</S.NumberCircle>
          <div>
            <Text strong className="highlight">
              אנחנו מאמינים בלעשות את הדבר הנכון
            </Text>
            <Paragraph>מודעים שהמבוטחים סומכים, מתנהלים ביושר מול לקוחותינו ומול חברות הביטוח</Paragraph>
          </div>
        </S.FeatureItem>

        <S.FeatureItem>
          <S.NumberCircle>2</S.NumberCircle>
          <div>
            <Text strong className="highlight">
              מקצועיות ושקיפות
            </Text>
            <Paragraph>
              אנחנו מקפידים על תשאול מעמיק ומקצועי כדי להבין את צרכי הבניין שלכם ולהציע כיסויים מתאימים
            </Paragraph>
          </div>
        </S.FeatureItem>

        <S.FeatureItem>
          <S.NumberCircle>3</S.NumberCircle>
          <div>
            <Text strong className="highlight">
              ליווי צמוד
            </Text>
            <Paragraph>
              אנו זמינים לכל שאלה ולצדכם לאורך כל הדרך – ברגעי שגרה, ברגעי חירום, ברגישות ובאכפתיות אמיתית
            </Paragraph>
          </div>
        </S.FeatureItem>

        <S.FeatureItem>
          <S.NumberCircle>4</S.NumberCircle>
          <div>
            <Text strong className="highlight">
              ותק וניסיון
            </Text>
            <Paragraph>למעלה מ-50 שנות ניסיון וידע עשיר בדיוק בתחום ביטוח הבתים המשותפים</Paragraph>
          </div>
        </S.FeatureItem>
      </S.Features>

      {/* --- STATS SECTION --- */}
      <S.Stats>
        <S.StatCard>
          <Text className="stat-number">18 שניות</Text>
          <Text className="stat-label">זמן ממוצע לשירות טלפוני</Text>
        </S.StatCard>

        <S.StatCard>
          <Text className="stat-number">7</Text>
          <Text className="stat-label">חברות ביטוח לבחירתך</Text>
        </S.StatCard>

        <S.StatCard>
          <Text className="stat-number">5,000</Text>
          <Text className="stat-label">תביעות מטופלות בשנה</Text>
        </S.StatCard>

        <S.StatCard>
          <Text className="stat-number">30,000</Text>
          <Text className="stat-label">לקוחות שבעי־רצון ובטוחים</Text>
        </S.StatCard>
      </S.Stats>

      <S.Footer>
        <S.CollapseWrapper accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          <Panel
            header={
              <S.PanelHeader>
                <S.IconWrapper>
                  {activeKey === 'Who we are' ? (
                    <MinusOutlined className="plus-icon" />
                  ) : (
                    <PlusOutlined className="plus-icon" />
                  )}
                </S.IconWrapper>
                <S.AvatarWrapper src={TarbutIcon} />
                <Text strong className="footer-text">
                  האגודה לתרבות הדיור סומכת עלינו
                </Text>
              </S.PanelHeader>
            }
            showArrow={false}
            key="Who we are"
          >
            <S.Wrapper>
              <S.UserContentBlock>
                <Paragraph>
                  האגודה לתרבות הדיור, הגוף הממשלתי המשמעותי בארץ המלווה ועדי בתים, <b>בחרה בנו</b> כסוכנות הביטוח
                  המלווה את ועדי הבתים החברים באגודה (כ-25,000 ועדי בתים).
                </Paragraph>
              </S.UserContentBlock>
              <S.UserWrapper>
                <Avatar className="user-icon" src={IntroUserIcon} size={85} />
                <S.UserContent>
                  <Title level={5} className="title">{`ראובן צדוק`}</Title>
                  <Paragraph className="sub-text">{`מנכ״ל האגודה`}</Paragraph>
                </S.UserContent>
              </S.UserWrapper>
              <S.UserContentBlock>
                <Paragraph>
                  ״בחרנו בבר-עוז המרכז לביטוח בתים משותפים לייצוג ועדי הבתים החברים באגודה, כי לסוכנות זו{' '}
                  <span className="bold">התמחות של עשרות שנים</span> במתן שירות ובטיפול בועדי בתים, ולאחר שמצאנו שהיא{' '}
                  <span className="bold">מספקת שירות יוצא דופן באיכותו</span> ללקוחותיה בהם ועדי בתים החברים באגודה.״
                </Paragraph>
              </S.UserContentBlock>
            </S.Wrapper>
          </Panel>
        </S.CollapseWrapper>
      </S.Footer>
    </S.Wrapper>
  );
};

export default DealRoomAgencyInfo;
